import { ReactNode } from "react";
import styled from "styled-components";

interface AccordionProps {
  children: ReactNode;
  isOpen?: boolean;
  hasBorder?: boolean;
  margin?: string;
  customWidth?: string;
  forceWidth?: string;
  className?: string;
}

interface ContentProps {
  isOpen?: boolean;
  hasBorder?: boolean;
  margin?: string;
  customWidth?: string;
  forceWidth?: string;
}

export function Accordion({ children, isOpen, hasBorder = true, margin = "14px", customWidth = "100%", forceWidth, className }: AccordionProps) {
  return (
    <Content
      className={className}
      isOpen={isOpen}
      hasBorder={hasBorder}
      margin={margin}
      customWidth={customWidth}
      forceWidth={forceWidth}
    >
      { children }
    </Content>
  );
}

const Content = styled.div<ContentProps>`
  width: ${({ customWidth }) => `${customWidth}`};

  @media screen and (max-width: ${({ theme }) => theme.device.tablet}) {
    width: ${({ forceWidth }) => forceWidth ? `${forceWidth}` : `100%`};
    transition: all 0.5s ease-in-out;
    margin: ${({ margin }) => `0 ${margin}`};
    overflow: hidden;
    max-height: ${({ isOpen }) => isOpen ? '5000px' : '0px'};
    border-bottom: ${({ theme, hasBorder }) => hasBorder && `2px solid ${theme.colors.blue.dark}`};
  }
`;